(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["afterpay"] && !Shopify.designMode) return;
  try {
    (() => {
    // adopted stylesheets live on the shadow root itself, so they survive square-placement re-rendering its
    // shadow content (an injected <style> got wiped on some amount changes and the logo flashed at its default size)
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(`
      .afterpay-logo.brand-afterpay svg,
      .afterpay-logo {
        width: 66px !important;
      }

      .cashappafterpay-with-word-pay-monthly {
        margin-right: 4px;
      }
    `);

    const adopt = (el, attempts = 0) => {
      const shadow = el.shadowRoot;
      if (!shadow) {
        // shadow root may attach a frame after the element connects
        if (attempts < 10) requestAnimationFrame(() => adopt(el, attempts + 1));
        return;
      }
      if (shadow.adoptedStyleSheets.includes(sheet)) return;
      shadow.adoptedStyleSheets = [...shadow.adoptedStyleSheets, sheet];
    };

    const adoptWithin = node => {
      if (node.nodeType !== Node.ELEMENT_NODE) return;
      if (node.matches('square-placement')) adopt(node);
      node.querySelectorAll('square-placement').forEach(el => adopt(el));
    };

    customElements.whenDefined('square-placement').then(() => {
      adoptWithin(document.documentElement);
      // only check added nodes (placements are added by the afterpay script, quickviews, and swatch changes)
      new MutationObserver(mutations => {
        mutations.forEach(mutation => mutation.addedNodes.forEach(adoptWithin));
      }).observe(document.documentElement, { childList: true, subtree: true });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["share-buttons"] && !Shopify.designMode) return;
  try {
    window.shareOnFacebook = ({ url = null, title = null, description = null } = {}) => {
    url = typeof url !== 'undefined' && url !== null ? url : window.location.href;
    title = typeof title !== 'undefined' && title !== null ? title : document.title;
    description = typeof description !== 'undefined' && description !== null ? description : '';
    if (typeof(FB) === "undefined" || !window.fbAsyncInit || !window.fbAsyncInit.hasRun) {
      window.open(
        'http://www.facebook.com/sharer.php?s=100&p[url]=' + encodeURIComponent(url) + '&p[title]=' + encodeURIComponent(title) + '&p[summary]=' + encodeURIComponent(description),
        'facebook-share-dialog',
        'width=626,height=436'
      );
    } else {
      FB.ui({ method: 'share', href: url });
    }
    return false;
  }

  window.shareOnPinterest = ({ url = null, title = null } = {}) => {
    url = typeof url !== 'undefined' && url !== null ? url : window.location.href;
    title = typeof title !== 'undefined' && title !== null ? title : document.title;
    window.open(
      '//www.pinterest.com/pin/create/button/?url=' + encodeURIComponent(url) + '&description=' + encodeURIComponent(title),
      'pinterest-share-dialog',
      'width=626,height=436'
    );
    return false;
  }

  // // Load Facebook SDK
  // window.fbAsyncInit = function() {
  //   FB.init({
  //     appId : 'YOUR_FACEBOOK_APP_ID',
  //     xfbml : true,
  //     version : 'v19.0' // or current version
  //   });
  // };

  // function shareOnFacebook() {
  //   FB.ui({
  //     method: 'share',
  //     href: 'https://yourwebsite.com',
  //   }, function(response) {
  //     // Callback logic if needed (e.g., alert on successful share)
  //   });
  // }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-javascript"] && !Shopify.designMode) return;
  try {
    (() => {
    // Open cart if wishlist item was just added to cart
    document.addEventListener('DOMContentLoaded', () => {
      subscribe(PUB_SUB_EVENTS.cartDrawerReady, e => {
        if (localStorage.getItem('swishlist:st-wishlist-add-to-cart') === 'true') {
          localStorage.removeItem('swishlist:st-wishlist-add-to-cart');
          window.updateCart();
        }
      });
    });


    // Watch dom for wisthlist modal
    const targetId = 'message_modal_text';
    const targetText = 'added to cart';
    const mainObserver = new MutationObserver((mutations) => {
      for (let mutation of mutations) {
        for (let node of mutation.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const matchingChild = node.querySelector(`#${targetId}`);

            if (matchingChild) {
              mainObserver.disconnect();

              // Watch text content of the matching child for changes
              const textObserver = new MutationObserver((textMutations) => {
                for (let textMutation of textMutations) {
                  // Watch text for 'added to cart' substring
                  if (matchingChild.textContent.trim().includes(targetText)) {
                    // Update local storage so we can open cart on page reload
                    localStorage.setItem('swishlist:st-wishlist-add-to-cart', 'true');
                  }
                }
              });

              // Start watching modal for child's text content
              textObserver.observe(matchingChild, {
                characterData: true,
                subtree: true,
                childList: true,
              });
            }
          }
        }
      }
    });

    // Start watching the body for wishlist modal
    mainObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
